export class Icon {
  alt: string;
  src: string;
  constructor(data: Icon) {
    this.alt = data.alt;
    this.src = data.src;
  }
}


export const IconsArray: Icon[] = [
  {
    alt: "default",
    src: "assets/icons/plane-up.svg"
  },
  {
    alt: "cross-close",
    src: "assets/icons/cross-close.svg"
  },
  {
    alt: "cart",
    src: "assets/icons/cart.svg"
  },
  {
    alt: "lk",
    src: "assets/icons/lk.svg"
  },
  {
    alt: "plane-up",
    src: "assets/icons/plane-up.svg"
  },
  {
    alt: "change",
    src: "assets/icons/change.svg"
  },
  {
    alt: "add",
    src: "assets/icons/add.svg"
  },
  {
    alt: "remove",
    src: "assets/icons/remove.svg"
  },
  {
    alt: "terms",
    src: "assets/icons/terms.svg"
  },
  {
    alt: "speed",
    src: "assets/icons/speed.svg"
  },
  {
    alt: "car",
    src: "assets/icons/car.svg"
  },
  {
    alt: "armchair",
    src: "assets/icons/armchair.svg"
  },
  {
    alt: "thunder",
    src: "assets/icons/thunder.svg"
  },
  {
    alt: "departure-plane",
    src: "assets/icons/departure-plane.svg"
  },
  {
    alt: "arrival-plane",
    src: "assets/icons/arrival-plane.svg"
  },
  {
    alt: "transit-plane",
    src: "assets/icons/transit-icon.svg"
  },
  {
    alt: "terminal",
    src: "assets/icons/terminal.svg"
  },
  {
    alt: "globe",
    src: "assets/icons/globe.svg"
  },
  {
    alt: "home",
    src: "assets/icons/home.svg"
  },
  {
    alt: "cart",
    src: "assets/icons/cart-m.svg"
  },
  {
    alt: "search",
    src: "assets/icons/search.svg"
  },
  {
    alt: "logo",
    src: "assets/icons/logo.svg"
  },
  {
    alt: "heart",
    src: "assets/icons/heart.svg"
  },
  {
    alt: "menu",
    src: "assets/icons/menu.svg"
  },
  {
    alt: "hamburger",
    src: "assets/icons/hamburger.svg"
  },
  {
    alt: "thin-cross",
    src: "assets/icons/thin-cross.svg"
  },
  {
    alt: "magnifier",
    src: "assets/icons/magnifier1.svg"
  },
  {
    alt: "arrow-right",
    src: "assets/icons/arrow-right.svg"
  },
  {
    alt: "sort-none",
    src: "assets/icons/sort-none.svg"
  },
  {
    alt: "sort-up",
    src: "assets/icons/sort-up.svg"
  },
  {
    alt: "sort-down",
    src: "assets/icons/sort-down.svg"
  },
  {
    alt: "square-arrow",
    src: "assets/icons/square-arrow.svg"
  },
  {
    alt: "arrowPageDouble",
    src: "assets/icons/arrow-page-double.svg"
  },
  {
    alt: "arrowPage",
    src: "assets/icons/arrow-page.svg"
  },


];
export const Icons = {
  default: IconsArray[0],
  crossClose: IconsArray[1],
  cart: IconsArray[2],
  lk: IconsArray[3],
  planeUp: IconsArray[4],
  change: IconsArray[5],
  add: IconsArray[6],
  remove: IconsArray[7],
  terms: IconsArray[8],
  speed: IconsArray[9],
  car: IconsArray[10],
  armchair: IconsArray[11],
  thunder: IconsArray[12],
  departurePlane: IconsArray[13],
  arrivalPlane: IconsArray[14],
  transitPlane: IconsArray[15],
  terminal: IconsArray[16],
  globe: IconsArray[17],
  home: IconsArray[18],
  cartM: IconsArray[19],
  search: IconsArray[20],
  logo: IconsArray[21],
  heart: IconsArray[22],
  menu: IconsArray[23],
  hamburger: IconsArray[24],
  thinClose: IconsArray[25],
  magnifier: IconsArray[26],
  arrowRight: IconsArray[27],
  sortNone: IconsArray[28],
  sortUp: IconsArray[29],
  sortDown: IconsArray[30],
  squareArrow: IconsArray[31],
  arrowPageDouble: IconsArray[32],
  arrowPage: IconsArray[33],
}
